import { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getAuth } from 'features/Auth/selectors'
import { Layout } from 'features/Layout'
import { PublicLayout } from 'features/Layout/PublicLayout'

interface IAppLayout {
  children: ReactNode
  disableLoginOnMobile?: boolean
}

export const AppLayout: FC<IAppLayout> = ({ children, disableLoginOnMobile = false }) => {
  const auth = useSelector(getAuth)

  return auth
    ? <Layout>{children}</Layout>
    : (
      <PublicLayout disableLoginOnMobile={disableLoginOnMobile}>
        {children}
      </PublicLayout>
    )
}
